<template>
  <projects-button :to="to" :title="$t('projects')"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ProjectsButton from '@/containers/Details/ProjectsButton'

export default {
  components: {
    ProjectsButton
  },
  computed: {
    ...mapState({ referral: state => state.nav.referral }),
    ...mapGetters(['hasReferral']),
    to () {
      return this.hasReferral && this.hasReferral.name === 'projects'
        ? { name: this.referral.name, query: this.referral.query, params: this.referral.params }
        : { name: 'projects' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Details/ProjectsButtonContainer.vue